import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/moneyin-general-types/moneyin/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
